import {
  SettingsCard,
  SettingsNote,
  SettingsPanel,
} from "../SettingsUI";

const shortcuts = [
  {
    category: "General",
    items: [
      { keys: ["Ctrl", "K"], action: "Open search" },
      { keys: ["Ctrl", ","], action: "Open settings" },
      { keys: ["Ctrl", "D"], action: "Open Assist Phone" },
      { keys: ["Esc"], action: "Close panel / Assist Phone" },
    ],
  },
  {
    category: "Chats",
    items: [
      { keys: ["Ctrl", "N"], action: "Start new chat" },
      { keys: ["Ctrl", "Enter"], action: "Send message" },
      { keys: ["Ctrl", "Shift", "M"], action: "Mute conversation" },
      { keys: ["↑"], action: "Edit last message" },
    ],
  },
  {
    category: "Calls",
    items: [
      { keys: ["Ctrl", "Shift", "C"], action: "Start voice call" },
      { keys: ["Ctrl", "Shift", "V"], action: "Start video call" },
      { keys: ["Ctrl", "Shift", "A"], action: "Answer incoming call" },
      { keys: ["Ctrl", "Shift", "E"], action: "End call" },
    ],
  },
  {
    category: "Navigation",
    items: [
      { keys: ["Ctrl", "1"], action: "Go to Home" },
      { keys: ["Ctrl", "2"], action: "Go to Messages" },
      { keys: ["Ctrl", "3"], action: "Go to Calls" },
      { keys: ["Ctrl", "4"], action: "Go to Contacts" },
    ],
  },
];

export function ShortcutsSection() {
  return (
    <SettingsPanel title="Keyboard shortcuts" description="Quick actions">
      {shortcuts.map((group) => (
        <SettingsCard key={group.category} title={group.category}>
          {group.items.map((item) => (
            <div
              key={`${group.category}-${item.action}`}
              className="flex items-center justify-between gap-3 px-4 py-3.5"
            >
              <p className="text-sm font-medium text-fg">{item.action}</p>
              <div className="flex flex-wrap items-center justify-end gap-1">
                {item.keys.map((key) => (
                  <kbd
                    key={`${item.action}-${key}`}
                    className="inline-flex min-w-7 items-center justify-center rounded-[6px] border border-border bg-surface-muted px-1.5 py-1 text-[11px] font-semibold text-fg"
                  >
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </SettingsCard>
      ))}

      <SettingsNote>
        Shortcuts are listed for reference. Global key bindings can be wired later.
      </SettingsNote>
    </SettingsPanel>
  );
}
